import { GiftCardsScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <GiftCardsScreen />;
}
